import FieldType from "./FieldType"
import DataType from "../data/DataType"

class FieldConfigs {
    static FORM = {
        type: FieldType.FORM,
        isBusinessField: true,
    }
    static TABLE = {
        type: FieldType.TABLE,
        isBusinessField: true,
    }
    static TAB = {
        type: FieldType.TAB,
        isBusinessField: true,
    }
    static PAGE = {
        type: FieldType.PAGE,
        isBusinessField: true,
    }

    static LABEL = {
        type: FieldType.LABEL,
    };
    static DETAIL = {
        type: FieldType.DETAIL,
    };
    static NUMBER = {
        type: FieldType.NUMBER,
        min: 0,
        max: null,
        precision: null,
        unit: null,
        unitModule: null,
        unitField: null,
    };
    static CURRENCY = {
        type: FieldType.NUMBER,
        min: 0,
        max: null,
        precision: 2,
        unit: null,
        unitModule: null,
        unitField: null,
    };
    static INPUT = {
        type: FieldType.INPUT,
        maxLength: 100,
    };
    static TEXTAREA = {
        type: FieldType.TEXTAREA,
        maxLength: 500,
    };
    static DATE = {
        type: FieldType.DATE,
        format: 'YYYY-MM-DD',
    };
    static TIME = {
        type: FieldType.TIME,
        format: 'HH:mm:ss',
    };
    static DATETIME = {
        type: FieldType.DATETIME,
        format: 'YYYY-MM-DD HH:mm:ss',
    };
    static SWITCH = {
        type: FieldType.SWITCH,
    };
    static TAG = {
        type: FieldType.TAG,
    };
    static SELECT = {
        type: FieldType.SELECT,
    }
    static MULTISELECT = {
        type: FieldType.MSELECT,
    }
    static TREESELECT = {
        type: FieldType.TREESELECT,
    }
    static MTREESELECT = {
        type: FieldType.MTREESELECT,
    }
    static SELECTION = {
        type: FieldType.SELECTION,
    }
    static MULTISELECTION = {
        type: FieldType.MSELECTION,
    }
    static CASCADE = {
        type: FieldType.CASCADE,
    }

    static getDataTypeConfig(dataType) {
        switch (dataType) {
            default: return FieldConfigs.LABEL;
            case DataType.NUMBER: return FieldConfigs.NUMBER;
            case DataType.CURRENCY: return FieldConfigs.CURRENCY;
            case DataType.STRING: return FieldConfigs.INPUT;
            case DataType.TEXT: return FieldConfigs.TEXTAREA;
            case DataType.DATE: return FieldConfigs.DATE;
            case DataType.TIME: return FieldConfigs.TIME;
            case DataType.DATETIME: return FieldConfigs.DATETIME;
            case DataType.BOOLEAN: return FieldConfigs.SWITCH;
            case DataType.TAG: return FieldConfigs.TAG;
        }
    }

    static getConfig(type) {
        if (!type) return FieldConfigs.LABEL;
        return FieldConfigs[type.toUpperCase()];
    }
    static getConfigs(configs) {
        const confs = [];
        for (const config of configs) {
            confs.push(Object.assign({}, FieldConfigs.getConfig(config.type), config));
        }
        return confs;
    }
}

export default FieldConfigs;
